import React, { useState, useEffect } from "react";
import "../../App.css";
import { apiPostAuth } from "../../utils/api"; // Use your axios wrapper
import { useNavigate } from "react-router-dom";

export default function AddGooglePlayAppPage() {
  const [packageName, setPackageName] = useState("");
  const [serviceEmail, setServiceEmail] = useState("");
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  // Fetch service email on page load
  useEffect(() => {
    const fetchServiceEmail = async () => {
      try {
        const response = await apiPostAuth("google_apps/get_service_email.php");
        if (response && response.service_email) {
          setServiceEmail(response.service_email);
        } else {
          setServiceEmail("serviceaccount@email.com");
        }
      } catch (error) {
        setServiceEmail("serviceaccount@email.com");
      } finally {
        setLoading(false);
      }
    };

    fetchServiceEmail();
  }, []);

  const validatePackageName = (name) => {
    const regex = /^[a-zA-Z][a-zA-Z0-9_]*(\.[a-zA-Z0-9_]+)+$/;
    return regex.test(name);
  };

  const handleConnect = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    if (!packageName.trim()) {
      setErrorMessage("Please enter the app package name.");
      return;
    }

    if (!validatePackageName(packageName)) {
      setErrorMessage(
        "Invalid package name format. Example: com.example.myapp"
      );
      return;
    }

    try {
      const response = await apiPostAuth("google_apps/check_app.php", {
        app_package_name: packageName,
      });
      if (response.result === 1) {
        navigate("/dashboard/add-google-play-app/app-detail", {
          state: { packageName },
        });
      } else {
        setErrorMessage(response.message || "Failed to connect app.");
      }
    } catch (error) {
      setErrorMessage("Oops, something went wrong. Please try again.");
    }
  };

  if (loading) {
    return (
      <div style={{ padding: "20px", textAlign: "center" }}>
        <div className="loading-spinner"></div>
        <p style={{ marginTop: "10px", color: "#4b5563" }}>Loading...</p>
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <button
        onClick={() => navigate(`/dashboard/google-play-review`)}
        style={backButtonStyle}
        >
        ← Back to App List
      </button>

      <h1 style={{ fontSize: "1.8rem", marginBottom: "10px", color: "#1f2937" }}>
        Add Google Play App or Game
      </h1>
      <p style={{ fontSize: "1rem", marginBottom: "30px", color: "#4b5563" }}>
        Connect a new Google Play app or game to automate your review responses.
      </p>

      {/* White container filling parent width */}
      <div
        style={{
          backgroundColor: "#fff",
          padding: "30px 20px",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
          width: "90%",
          marginBottom: "20px",
        }}
      >
        <h2 style={{ fontSize: "1.2rem", marginBottom: "10px", color: "#1f2937" }}>
          Steps to Connect App/Game:
        </h2>
        <ol style={{ color: "#4b5563", lineHeight: "1.6", paddingLeft: "20px" }}>
          <li>
            <strong>Connect Google Play Developer: </strong>
            Go to your Google Play Developer Console. Navigate to{" "}
            <em>Users and Permissions</em>. Click on the triple dot icon and select{" "}
            <em>Invite new users</em>. Fill the Email address with{" "}
            <code>{serviceEmail}</code>. Ensure the app you want to connect is
            allowed. Check the following permissions:
            <ul style={{ marginTop: "5px", paddingLeft: "20px" }}>
              <li>View app information and download bulk reports (read-only)</li>
              <li>Reply to reviews</li>
            </ul>
          </li>
          <li style={{ marginTop: "10px" }}>
            <strong>Input App Package Name:</strong> Enter the package name of your
            app/game below.
          </li>
        </ol>

        {/* Form inside the same container */}
        <form onSubmit={handleConnect} style={{ marginTop: "20px" }}>
          <label
            htmlFor="packageName"
            style={{
              display: "block",
              marginBottom: "8px",
              color: "#1f2937",
              fontWeight: "500",
            }}
          >
            App Package Name
          </label>
          <input
            id="packageName"
            type="text"
            value={packageName}
            onChange={(e) => setPackageName(e.target.value)}
            placeholder="com.example.myapp"
            style={{
              width: "90%",
              padding: "10px",
              border: "1px solid #ccc",
              borderRadius: "6px",
              marginBottom: "10px",
              fontSize: "1rem",
            }}
          />
          {errorMessage && (
            <p style={{ color: "red", fontSize: "0.9rem", marginBottom: "10px" }}>
              {errorMessage}
            </p>
          )}
          <button
            type="submit"
            className="primary-button"
            style={{ width: "150px" }}
          >
            Connect
          </button>
          <p style={{ fontSize: "0.85rem", marginTop: "8px", color: "#6b7280" }}>
            *This step is just for setup and does not start automation.
          </p>
        </form>
      </div>
    </div>
  );
}

const backButtonStyle = {
  display: "inline-block",
  padding: "8px 16px",
  backgroundColor: "#f2f6fc",
  color: "#2563eb",
  fontWeight: "500",
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  cursor: "pointer",
  marginBottom: "20px",
  transition: "all 0.2s ease",
};

backButtonStyle[":hover"] = {
  backgroundColor: "#e5e7eb",
};
